// extracted by mini-css-extract-plugin
export default {"confirmContent":"ConfirmModal_confirmContent__3Beus","message":"ConfirmModal_message__vx8at","footer":"ConfirmModal_footer__LQcxf"};